// extracted by mini-css-extract-plugin
module.exports = {"Plan-comparison":"PlanComparison_Plan-comparison__1P9ub","Plan-heading":"PlanComparison_Plan-heading__1rhcC"};